import styled from 'styled-components';

const Content = styled.div`
  background: var(--quiz-content-background-color);
  position: relative;
  max-width: 1024px;
  margin: 0 auto;

  & > :first-child {
    margin-top: 0;
  }

  & > :last-child {
    margin-bottom: 0;
  }
`;

export default Content;
